import { IGetState, TBoardId, TCardId, TPermissionId } from '../../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import {
    onToggle
} from '../../../../../../../aside_panel/cardDetails/AssigneesSection/hocs/AssigneesSearchSelectHOC/events/onToggle';
import {
    SegmentCardEvent,
    SegmentCardOptions,
    segmentTrackAction
} from '../../../../../../../../../middlewares/segment';
import { SegmentCardType } from '../../../../../../../../../middlewares/segment/trackEntities/cardEvents';

export const onSelect = (
    boardId: TBoardId,
    cardId: TCardId,
    permissionId: TPermissionId,
    source: SegmentCardType,
    permissionIds?: TPermissionId[],
    onOwnChange?: (permissionId: TPermissionId) => void,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        if (onOwnChange) {
            const option = {
                name: SegmentCardOptions.TYPE,
                value: source
            };
            if (permissionIds.includes(permissionId)) {
                dispatch(segmentTrackAction(SegmentCardEvent.UNASSIGNED_USER, option));
            } else {
                dispatch(segmentTrackAction(SegmentCardEvent.ASSIGNED_USER, option));
            }
            onOwnChange(permissionId);
        } else {
            dispatch(onToggle(boardId, [cardId], permissionId, source));
        }
    };
    return action;
};
